/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Schedule,
  Schedule$inboundSchema,
  Schedule$Outbound,
  Schedule$outboundSchema,
} from "./schedule.js";
import {
  Sequence,
  Sequence$inboundSchema,
  Sequence$Outbound,
  Sequence$outboundSchema,
} from "./sequence.js";

/**
 * Kind of the condition value
 */
export const ConditionValueKind = {
  Number: "number",
  Boolean: "boolean",
  Enum: "enum",
  Schedule: "schedule",
  Sequence: "sequence",
  String: "string",
  EnumArray: "enum_array",
} as const;
/**
 * Kind of the condition value
 */
export type ConditionValueKind = OpenEnum<typeof ConditionValueKind>;

/**
 * A value used in a condition
 */
export type ConditionValue = {
  /**
   * Boolean setting value
   */
  boolean?: boolean | undefined;
  /**
   * Enum setting value
   */
  enum?: string | undefined;
  /**
   * Enum array value used in Some or Every conditions
   */
  enumArray?: Array<string> | undefined;
  /**
   * Kind of the condition value
   */
  kind: ConditionValueKind;
  /**
   * Number setting value
   */
  number?: number | undefined;
  /**
   * The schedule value of
   */
  schedule?: Schedule | undefined;
  /**
   * The sequence value
   */
  sequence?: Sequence | undefined;
  /**
   * String setting value
   */
  string?: string | undefined;
};

/** @internal */
export const ConditionValueKind$inboundSchema: z.ZodType<
  ConditionValueKind,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(ConditionValueKind);
/** @internal */
export const ConditionValueKind$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  ConditionValueKind
> = openEnums.outboundSchema(ConditionValueKind);

/** @internal */
export const ConditionValue$inboundSchema: z.ZodType<
  ConditionValue,
  z.ZodTypeDef,
  unknown
> = z.object({
  boolean: types.optional(types.boolean()),
  enum: types.optional(types.string()),
  enum_array: types.optional(z.array(types.string())),
  kind: ConditionValueKind$inboundSchema,
  number: types.optional(types.number()),
  schedule: types.optional(Schedule$inboundSchema),
  sequence: types.optional(Sequence$inboundSchema),
  string: types.optional(types.string()),
}).transform((v) => {
  return remap$(v, {
    "enum_array": "enumArray",
  });
});
/** @internal */
export type ConditionValue$Outbound = {
  boolean?: boolean | undefined;
  enum?: string | undefined;
  enum_array?: Array<string> | undefined;
  kind: string;
  number?: number | undefined;
  schedule?: Schedule$Outbound | undefined;
  sequence?: Sequence$Outbound | undefined;
  string?: string | undefined;
};

/** @internal */
export const ConditionValue$outboundSchema: z.ZodType<
  ConditionValue$Outbound,
  z.ZodTypeDef,
  ConditionValue
> = z.object({
  boolean: z.boolean().optional(),
  enum: z.string().optional(),
  enumArray: z.array(z.string()).optional(),
  kind: ConditionValueKind$outboundSchema,
  number: z.number().optional(),
  schedule: Schedule$outboundSchema.optional(),
  sequence: Sequence$outboundSchema.optional(),
  string: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    enumArray: "enum_array",
  });
});

export function conditionValueToJSON(conditionValue: ConditionValue): string {
  return JSON.stringify(ConditionValue$outboundSchema.parse(conditionValue));
}
export function conditionValueFromJSON(
  jsonString: string,
): SafeParseResult<ConditionValue, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ConditionValue$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ConditionValue' from JSON`,
  );
}
